/* eslint-disable import/prefer-default-export */
import { InquiryStatusType } from '../../../../../interface/inquiry';

export const getIsReplied = (status?: InquiryStatusType) => {
	return status === 'replied';
};
